// Web3Forms access key — form-to-email connector (no third-party tracker).
// Shared so both the contact form and the devis wizard deliver to contact@yaslan.be.
export const WEB3FORMS_KEY = '80c6a15d-2fe2-45f6-a95e-7804a43fa400'
export const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit'
